import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { SpacesState } from './types';

export const getSpacesState = (state: StoreState): SpacesState => state.spaces;

export const getRelatedFloors = createSelector(
  getSpacesState,
  ({ space }) => new Map((space?.relatedFloors ?? []).map(f => [f.floorId, f])),
);
